/*
**************************** 
홈페이지 푸터
*****************************
*/

import React from "react"

const span = {
    display: "inline-block",
    fontSize: "13px",
    color: "#8d8d8d",
    lineHeight: "16px",
    margin: "0 0 8px 0",
    textDecoration: "none"
}

export default function Footer() {
    return (
        <div className="container">
            <footer className="bd-footer  bg-white">
                <div className="container py-5">
                    <div className="row">
                    </div>
                    <div className="mb-3 text-secondary small text-muted">
                        <div style={{ wordSpacing: "2pt" }}  >
                            <span>COMPANY. 주식회사 엘포박스</span><span></span> | <span>TEL. 02)969-8722</span><span>E-MAIL. jay@l4box.com</span> <br />
                            <span>ADDRESS. HQ 서울 강서구 마곡중앙8로 14 서울창업허브 엠플러스 607호 </span>
                            <span>BUSINESS LICENSE. 774-81-02262 </span><br></br>
                            <span>통신판매업 신고번호: 제 2023-서울성북-0412</span> | <span>개인정보관리책임자 : 장현우 </span> |
                            <span ><a href="https://peach-margin-2a3.notion.site/d6da601eddaa4953a20daf459ba61da0" target="_blank" className="text-muted text-decoration-none" > 서비스 이용약관</a></span> |
                            <span> </span><a href="https://peach-margin-2a3.notion.site/fd1b89b6ea534e659809b6fcb8c9ae58" target="_blank" className="text-muted text-decoration-none"><span > 개인정보처리방침</span> | </a>
                            <span> </span><a href="https://peach-margin-2a3.notion.site/e9c69c0082f743329b750b7b8ca3cc8c" target="_blank" className="text-muted text-decoration-none"><span > 전자상거래 이용약관</span> | </a>
                            <span> </span><a href="https://peach-margin-2a3.notion.site/320a0f659c6b415cb697cdecca0b99eb" target="_blank" className="text-muted text-decoration-none"><span > 콘텐츠 환불정책</span></a><br /><br />
                            <span>COPYRIGHT BY 주식회사 엘포박스 ALL RIGHTS RESERVED.</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}
